const UI_EVENTS = {
  PLAY_TRIGGERED: 'ui-play-triggered',
  PLAY_OVERLAY_TRIGGERED: 'ui-play-overlay-triggered',
  PAUSE_TRIGGERED: 'ui-pause-triggered',
  PROGRESS_CHANGE_TRIGGERED: 'ui-progress-change-triggered',
  VOLUME_CHANGE_TRIGGERED: 'ui-volume-change-triggered',
  MUTE_STATUS_TRIGGERED: 'ui-mute-status-triggered',
  FULLSCREEN_STATUS_CHANGED: 'ui-fullscreen-status-changed',
  MOUSE_ENTER_ON_PLAYER_TRIGGERED: 'ui-mouse-enter-on-player-triggered',
  MOUSE_MOVE_ON_PLAYER_TRIGGERED: 'ui-mouse-move-on-player-triggered',
  MOUSE_LEAVE_ON_PLAYER_TRIGGERED: 'ui-mouse-leave-on-player-triggered',
  CONTROL_BLOCK_HIDE_TRIGGERED: 'ui-control-block-hide-triggered',
  CONTROL_BLOCK_SHOW_TRIGGERED: 'ui-control-block-show-triggered',
  PROGRESS_MANIPULATION_STARTED: 'ui-progress-manipulation-started',
  PROGRESS_MANIPULATION_ENDED: 'ui-progress-manipulation-ended',
  KEYBOARD_KEYDOWN_INTERCEPTED: 'ui-keyboard-keydown-intercepted',
  LOADER_SHOW_TRIGGERED: 'ui-loader-show-triggered',
  LOADER_HIDE_TRIGGERED: 'ui-loader-hide-triggered',
  LOADING_COVER_SHOW_TRIGGERED: 'ui-loading-cover-show-triggered',
  LOADING_COVER_HIDE_TRIGGERED: 'ui-loading-cover-hide-triggered',
  TOGGLE_PLAYBACK_WITH_KEYBOARD_TRIGGERED:
    'ui-toggle-playback-with-keyboard-triggered',
  GO_BACKWARD_WITH_KEYBOARD_TRIGGERED: 'ui-go-backward-with-keyboard-triggered',
  GO_FORWARD_WITH_KEYBOARD_TRIGGERED: 'ui-go-forward-with-keyboard-triggered',
  INCREASE_VOLUME_WITH_KEYBOARD_TRIGGERED:
    'ui-increase-volume-with-keyboard-triggered',
  DECREASE_VOLUME_WITH_KEYBOARD_TRIGGERED:
    'ui-decrease-volume-with-keyboard-triggered',
  MUTE_SOUND_WITH_KEYBOARD_TRIGGERED: 'ui-mute-sound-with-keyboard-triggered',
  UNMUTE_SOUND_WITH_KEYBOARD_TRIGGERED:
    'ui-unmute-sound-with-keyboard-triggered',
  HIDE_INTERACTION_INDICATOR_TRIGGERED:
    'ui-hide-interaction-indicator-triggered',
  PLAYER_WIDTH_CHANGE_TRIGGERED: 'ui-player-width-change-triggered',
  PLAYER_HEIGHT_CHANGE_TRIGGERED: 'ui-player-height-change-triggered',
  PLAY_WITH_SCREEN_CLICK_TRIGGERED: 'ui-play-with-screen-click-triggered',
  PAUSE_WITH_SCREEN_CLICK_TRIGGERED: 'ui-pause-with-screen-click-triggered',
  CONTROL_DRAG_START: 'ui-control-drag-start',
  CONTROL_DRAG_END: 'ui-control-drag-end',
  MAIN_BLOCK_HIDE_TRIGGERED: 'ui-main-block-hide-triggered',
  MAIN_BLOCK_SHOW_TRIGGERED: 'ui-main-block-show-triggered',
};

export default UI_EVENTS;



// WEBPACK FOOTER //
// ./constants/events/ui.ts